export default __webpack_public_path__ + "static/media/books2-afterB-2048w.8016534d.avif";